import React, { Component } from 'react';
import { inject, observer } from 'mobx-react'
import PopularPack from './PopularPack';

@inject('sidebarStore')
@observer
class PopularPacks extends Component {
  render() {
    if (this.props.products.length <= 1) return null

    return (
      <div className='flex flex-col mb-5'>
        <p className='text-2xl font-bold mb-5 leading-none'>{this.props.title}</p>
        {
          this.props.products.map((pack, i) => (
            <PopularPack key={i} pack={pack} number={i} />
          ))
        }
      </div>
    )
  }
}

export default PopularPacks;
